import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * NOTE: `class MyError extends Error` does not work correctly with the `instanceof` operator in some environments like
 * Jest where ES6 classes are downleveled. Instead of directly extending `Error`, extending this class will ensure that
 * the `instanceof` operator works correctly.
 *
 * @example
 * ```typescript
 * class MyError extends ExtendableError {}
 * ```
 *
 * @see https://github.com/Microsoft/TypeScript/issues/13965
 */
var ExtendableError = /*#__PURE__*/function (_Error) {
  _inherits(ExtendableError, _Error);
  var _super = _createSuper(ExtendableError);
  function ExtendableError(message) {
    var _this;
    _classCallCheck(this, ExtendableError);
    _this = _super.call(this, message);

    // NOTE: This is required for some environments like Jest where ES6 classes are downleveled to ES5 syntax. This
    // breaks the the `instanceof` operator for `class MyError extends Error {}`
    // i.e. `(new MyError instanceof MyError) === false`
    // Instead `class MyError extends ExtendableError {}` and `new MyError instanceof MyError` will work as expected
    // @see https://github.com/Microsoft/TypeScript/issues/13965
    //
    // This is safe to call in ES6+ environments, but can cause significant deoptimisation, so avoid it unless necessary
    // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf#:~:text=very%20slow%20operation
    /* istanbul ignore if */
    if (!(_assertThisInitialized(_this) instanceof ExtendableError)) {
      Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof ExtendableError ? this.constructor : void 0).prototype);
    }
    return _this;
  }
  return _createClass(ExtendableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { ExtendableError as default };
//# sourceMappingURL=ExtendableError.js.map
